import React, {Fragment, useEffect, useState} from 'react';

import {getCountries} from './DropdownDataProviders' ;

import { renderDropdown, renderDropdownReadOnly} from "./DropdownFunctions";

import SpinnerDiv from "./SpinnerDiv";
import PropTypes from "prop-types";

const DropdownCountries= ( props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getCountries().then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })
    }, []);

    const options = {
        isSearchable: true,
        isClearable: props.isClearable === null || props.isClearable === undefined ? true : props.isClearable,
    }

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data, options)
    )
}

export default DropdownCountries;

DropdownCountries.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownCountries.propTypes = {
    onChange: PropTypes.func.isRequired
};